import { Stars } from '../Stars/Stars';
import styles from './ReviewCard.module.scss';

export interface ReviewCardProps {
  rating: number;
  review: string;
  index?: number;
}

export const ReviewCard = ({ rating, review, index = 0 }: ReviewCardProps) => {
  const reviewNumber = `${index + 1}`.padStart(2, '0');

  return (
    <li className={styles.root}>
      <div className={styles.header}>
        <span className={styles.kicker}>Patient review {reviewNumber}</span>
        <Stars rating={rating} />
      </div>
      <blockquote className={styles.quote}>
        <p>{review}</p>
      </blockquote>
    </li>
  );
};
